// Get current date in America/Chicago timezone as YYYY-MM-DD
export function todayCDT() {
  return dateToCDT(new Date());
}

// Convert a Date to YYYY-MM-DD in America/Chicago timezone
export function dateToCDT(date) {
  const parts = date.toLocaleDateString('en-CA', { timeZone: 'America/Chicago' });
  return parts; // en-CA locale returns YYYY-MM-DD format
}

// Get a Date object representing "now" in CDT (for day-of-week, etc.)
export function nowCDT() {
  const str = new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' });
  return new Date(str);
}
